
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { NgCustomDropdownComponent } from './custom-dropdown/custom-dropdown.component';
import { NgDirectivesModule } from '../../../directives/directives.module';
import { NgStylingComponentsModule } from '../../../styling-components/styling-components.module';
import { NgPipesModule } from '../../../pipes/pipes.module';


@NgModule({
	declarations: [
		NgCustomDropdownComponent
	],
	imports: [
		CommonModule,
		NgbModule,
		NgDirectivesModule,
		NgPipesModule,
		NgStylingComponentsModule
	],
	exports: [
		NgCustomDropdownComponent
	]
})
export class NgDropdownsModule { }
